/* ============================================================
   FRAISE NOIRE — ZOOM LOUPE
   Survol desktop : l'image s'agrandit autour du curseur pour
   révéler le relief de la broderie — l'argument n°1 de la maison.
   Tactile : un appui ouvre/ferme le zoom, le doigt le déplace.
   Ne s'active jamais en reduced-motion.

   Une seule cible : les visuels de la fiche produit (.pdp__shot). La loupe
   de l'accueil a été retirée à la demande.
   ============================================================ */
(() => {
  'use strict';
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const tactile = matchMedia('(hover: none)').matches;

  /* Arme un cadre : l'image se met à l'échelle en gardant le point
     survolé sous le curseur (transform-origin en pourcentage). */
  function armer(cadre, opts) {
    const img = cadre.querySelector('img');
    if (!img) return;
    // lu à chaque ouverture, pour qu'un appelant puisse faire varier le
    // grossissement (par exemple selon la largeur de la fenêtre)
    const niveau = () => opts.niveau;
    cadre.classList.add(opts.classePrete);

    if (opts.indice) {
      const pin = document.createElement('span');
      pin.className = opts.classeIndice;
      pin.innerHTML = `<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.2-3.2M11 8.5v5M8.5 11h5"/></svg><i>${tactile ? opts.indice.tactile : opts.indice.souris}</i>`;
      cadre.appendChild(pin);
    }

    let actif = false;
    const placer = e => {
      const r = cadre.getBoundingClientRect();
      const p = e.touches ? e.touches[0] : e;
      const x = Math.max(0, Math.min(100, ((p.clientX - r.left) / r.width) * 100));
      const y = Math.max(0, Math.min(100, ((p.clientY - r.top) / r.height) * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
    };
    const ouvrir = e => {
      actif = true;
      cadre.classList.add('is-zoom');
      img.style.transform = 'scale(' + niveau() + ')';
      placer(e);
    };
    const fermer = () => {
      actif = false;
      cadre.classList.remove('is-zoom');
      img.style.transform = '';
      img.style.transformOrigin = '';
    };

    /* AU CLAVIER AUSSI.
       Le zoom sur la broderie est l'argument numero un de la maison : c'est la
       qu'on voit le fil. Il n'etait accessible qu'a la souris et au doigt —
       ni focusable, ni declenchable, donc invisible pour qui navigue au
       clavier ou au lecteur d'ecran. On le rend atteignable et actionnable,
       en zoomant au centre de l'image, et Echap referme. */
    if (!cadre.hasAttribute('tabindex')) {
      cadre.setAttribute('tabindex', '0');
      cadre.setAttribute('role', 'button');
      cadre.setAttribute('aria-label', 'Agrandir la photo pour voir le détail');
    }
    const centre = () => {
      const r = cadre.getBoundingClientRect();
      return { clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 };
    };
    cadre.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        actif ? fermer() : ouvrir(centre());
        cadre.setAttribute('aria-pressed', actif ? 'true' : 'false');
      } else if (e.key === 'Escape' && actif) {
        fermer(); cadre.setAttribute('aria-pressed', 'false');
      }
    });
    cadre.addEventListener('blur', () => { if (actif) fermer(); });

    if (tactile) {
      cadre.addEventListener('click', e => { actif ? fermer() : ouvrir(e); });
      cadre.addEventListener('touchmove', e => { if (actif) { e.preventDefault(); placer(e); } }, { passive: false });
    } else {
      cadre.addEventListener('pointerenter', ouvrir);
      cadre.addEventListener('pointermove', e => { if (actif) placer(e); });
      cadre.addEventListener('pointerleave', fermer);
    }
  }

  /* ---- fiche produit ---- */
  const gal = document.querySelector('.pdp__gallery');
  if (gal) gal.querySelectorAll('.pdp__shot').forEach(shot => armer(shot, {
    niveau: 2.1,
    classePrete: 'pdp__shot--zoom',
    classeIndice: 'pdp__zoomhint',
    indice: { tactile: 'Touche pour zoomer', souris: 'Survole pour zoomer' },
  }));

})();
